import { createSlice } from "@reduxjs/toolkit";

interface InitialState {
  tabSettings: {
    tab: number;
    filter: {};
  };
}

const initialState: InitialState = {
  tabSettings: {
    tab: 0,
    filter: "",
  },
};

const configAcessosSlice = createSlice({
  name: "acessosApp/acessos",
  initialState,
  reducers: {
    changeTab: (state, action) => {
      state.tabSettings.tab = action.payload;
    },
    clearFilter: (state) => {
      state.tabSettings.filter = "";
    },
  },
});

export const { changeTab, clearFilter } =
  configAcessosSlice.actions;

export default configAcessosSlice.reducer;
